import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ISessionService } from '@insight/services';
import { environment as env } from 'projects/insight/src/environments/environment';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private activatedRoute: ActivatedRoute,
    private sessionService: ISessionService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const headersConfig: any = {
      Accept: 'application/json',
      'Api-Key': env.apiKey
    };

    if (request.headers.has('Authorization')) {
      headersConfig['Authorization'] = request.headers.get('Authorization');
    }

    if (request.headers.has('Content-Type')) {
      headersConfig['Content-Type'] = request.headers.get('Content-Type');
    }

    request = request.clone({
      setHeaders: headersConfig
    });

    /**
     * INI UNTUK QUERY TOKEN -> TOKEN YANG DI INJECT DI URL
     * NEED TO REMOVE PARAM AFTER TOKEN HANDLED !!!
     */
    const queryToken = this.activatedRoute.snapshot.queryParamMap.get('token');
    if (queryToken) {
      return next.handle(this.injectQueryToken(request));
    }
    // if no token found, then just send it as is,
    // it must be from non login page (i.e public page)
    // let the api decide wether this request may or not pass
    if (!this.sessionService.getUserToken()) {
      return next.handle(request);
    }

    // if url includes refresh-token,
    // then it must from this interceptor mekanism, let it pass
    if (request.url.includes('refresh-token')) {
      return next.handle(request);
    }

    const tokenExpired = this.sessionService.isTokenExpired();
    if (tokenExpired) {
      console.log('Token expired, refreshing..');
      return this.sessionService.refreshToken()
        .pipe(
          switchMap(() => {
            return next.handle(this.injectToken(request));
          })
        );
    } else {
      return next.handle(this.injectToken(request));
    }
  }

  private injectToken(request: HttpRequest<any>) {
    const userToken = this.sessionService.getUserToken();
    if (request.headers.has('Authorization')) {
      return request;
    }

    return request.clone({
      headers: request.headers.set('Authorization', userToken)
    });;
  }

  private injectQueryToken(request: HttpRequest<any>) {
    const token = this.activatedRoute.snapshot.queryParamMap.get('token');
    return request.clone({
      headers: request.headers.set('Authorization', token)
    });
  }
}
